import { Reducer } from "redux";

import { DocumentListResponse } from "../models/Api/AuthorizationDetailsTab";
import { DocumentListDispatchTypes } from "../models/DispatchTypes/AuthorizationDetailstab";
import { DocumentListActionDispatchTypes } from "../constants/Document";

const initialState: DocumentListResponse = {
    loading: false,
    response: [],
    error: null,
}


const GetDocumentListReducer: Reducer<
DocumentListResponse,
DocumentListDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DocumentListActionDispatchTypes.GET_DOCUMENT_LIST_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DocumentListActionDispatchTypes.GET_DOCUMENT_LIST_SUCCESS: {
      return {
        ...state,
          response: action.response,
        loading: false,
      };
    }
    case DocumentListActionDispatchTypes.GET_DOCUMENT_LIST_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
      }
      case DocumentListActionDispatchTypes.GET_DOCUMENT_LIST_RESET: {
          return initialState;
      }
  }
  return state;
};

export default GetDocumentListReducer;
